const errorMsg = {
    ERROR_UNKNOWN: '未知错误',
    ECONNABORTED: '请求超时，请稍后重试～',
    NETWORK_ERROR: '网络中断，请检查网络连接是否正常～',
    TOKEN_EXPIRED: '无效的登录，请尝试重新登录～',
    RESET_SUCCESS: '重置成功!',
    RESET_FAILED: '重置失败!',
    SAVE_SUCCESS: '该作品已保存，点击头像进入【个人中心】中刷新页面查看和分享作品！',
    LOGIN_ALERT: '登录后才可以保存哦！请在首页点击右上角头像进行登录',
    SAVE_FAILED: '保存失败！',
    SAVE_ERROR: '项目保存遇到问题了，再试一次吧',
    RUN_SAVE_ERROR: '项目运行过程中保存失败',
    CHECK_SAVE_ERROR: '项目检查过程中保存失败',
    CHECK_RESULT_SAVE_ERROR: '判题结果保存失败'
}
export default errorMsg;